import React from 'react';
import { styled } from '@mui/material/styles';

interface IProps {
  className?: string;
  children: React.ReactNode;
  component?: React.ElementType;
}

const Component = React.forwardRef<HTMLElement, IProps>((props, ref) => {
  return React.createElement(props.component || 'div', {
    className: props.className,
    children: props.children,
    ref,
  });
});

export const ScrollablePageContent = styled(Component)(() => ({
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
}));
